import styled from 'styled-components'
import { ThemeSelectors } from '@at/design-system-foundation'
import { BREAKPOINTS } from '@at/window-utils/lib/responsive-utils/match-media.util'
import { Button } from '@at/design-system-elements'
import { isRedButtonTestActive } from '../../utils/red-button-test'

export const StyledSearchListings = styled.div`
    position: relative;
`

export enum GRID_COLUMNS {
    NARROW = 1,
    MEDIUM = 8,
    WIDE = 12,
    EXWIDE = 15,
}

export const StyledSearch = styled.section`
    @media (max-width: 678px) {
        .skeleton:nth-child(n + 4) {
            display: none;
        }
    }

    @media (min-width: 679px) and (max-width: ${BREAKPOINTS.MEDIUM - 1}px) {
        .skeleton:nth-child(n + 5) {
            display: none;
        }
    }

    @media (min-width: ${BREAKPOINTS.MEDIUM}px) and (max-width: ${BREAKPOINTS.WIDE - 1}px) {
        .skeleton:nth-child(n + 8) {
            display: none;
        }
    }

    @media (min-width: ${BREAKPOINTS.WIDE}px) {
        .skeleton:nth-child(n + 11) {
            display: none;
        }
    }

    > ul,
    .infinite-scroll-component {
        margin: 0;
        display: grid;
        column-gap: 24px;
        grid-template-columns: repeat(${GRID_COLUMNS.NARROW}, 1fr);
        padding: 2px;

        @media (min-width: 640px) {
        }

        @media (min-width: ${BREAKPOINTS.MEDIUM}px) {
            grid-template-columns: repeat(${GRID_COLUMNS.MEDIUM}, 1fr);
        }
        @media (min-width: ${BREAKPOINTS.WIDE}px) {
            grid-template-columns: repeat(${GRID_COLUMNS.WIDE}, 1fr);
        }
        @media (min-width: 1728px) {
            grid-template-columns: repeat(${GRID_COLUMNS.EXWIDE}, 1fr);
        }
    }
`

export const StyledBackToTop = styled.a`
    span {
        line-height: 1.2;
    }
    &:hover {
        cursor: pointer;
        opacity: 1;
    }
    align-items: center;
    background-color: ${({ theme }) =>
        isRedButtonTestActive ? theme.color.bgFill.intense : theme.color.bgFill.default};
    border-radius: 50%;
    bottom: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
    box-shadow: 0 2px 3px 0 ${({ theme }) => theme.color.border.default};
    display: flex;
    height: 40px;
    justify-content: center;
    opacity: 0.9;
    padding: 12px 0;
    position: fixed;
    right: ${({ theme }) => ThemeSelectors.getLegacyGridUnit(theme) * 2}px;
    text-align: center;
    width: 40px;
    z-index: 4;
`

export const StyledPreviousResultsButtonContainer = styled.div`
    display: flex;
    justify-content: center;
`
export const StyledLoadPreviousResultsButton = styled(Button)`
    span {
        margin-right: 0;
    }
`

export const RetailerStockWrapper = styled.div`
    display: flex;
    flex-direction: column;
`
